import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { Card, CardBody, CardTitle, Button, ButtonGroup } from 'reactstrap';
import { getSubscriptionAnalytics } from '../../../../../api-handle/subscriptionApi';
import { Calendar } from 'lucide-react';
import Loader from '../../../../../CommonElements/Loader/loader';

const SubscriptionAnalytics = () => {
    const [data, setData] = useState({
        categories: [],
        series: []
    });
    const [range, setRange] = useState('daily');
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await getSubscriptionAnalytics({ range });
            const revenue = res?.revenue || [];

            // Extract categories (label - formatted date like "14/4/2025")
            const categories = revenue.map(item => item.label);

            // Extract revenue and subscription counts for series
            const revenueSeries = revenue.map(item => item.totalRevenue);
            const countSeries = revenue.map(item => item.count);

            setData({
                categories,
                series: [
                    { name: 'Revenue', data: revenueSeries },
                    { name: 'Subscriptions Sold', data: countSeries }
                ]
            });
        } catch (err) {
            console.error('Error fetching analytics:', err);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [range]);

    return (
        <Card style={{ marginTop: '20px' }} className="shadow-sm">
            <CardBody>
                <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-sm-between gap-2 mb-3">
                    <CardTitle tag="h5" className="text-black d-flex align-items-center gap-2 mb-0">
                        <Calendar size={20} /> Subscription Revenue Analytics
                    </CardTitle>
                    <ButtonGroup>
                        {['daily', 'weekly', 'monthly'].map(mode => (
                            <Button
                                key={mode}
                                color={range === mode ? 'primary' : 'outline-black'}
                                onClick={() => setRange(mode)}
                            >
                                {mode.charAt(0).toUpperCase() + mode.slice(1)}
                            </Button>
                        ))}
                    </ButtonGroup>
                </div>

                {loading ? (
                    <Loader />
                ) : (
                    <Chart
                        options={{
                            chart: { id: 'subscription-revenue' },
                            xaxis: { categories: data.categories },
                            stroke: { curve: 'smooth' },
                            dataLabels: { enabled: false },
                            colors: ['#0d6efd', '#6c757d']
                        }}
                        series={data.series}
                        type="line"
                        height={350}
                    />
                )}
            </CardBody>
        </Card>
    );
};

export default SubscriptionAnalytics;
